import { Component } from '@angular/core';

import type { User } from '@recruitee/account-types';
import { TranslatePipe } from '@recruitee/i18n';

import { AvatarComponent } from '../../../common/avatar/avatar.component';

/*
 eslint-disable
 @typescript-eslint/consistent-type-assertions,
 @angular-eslint/no-inputs-metadata-property,
*/

@Component({
  imports: [AvatarComponent, TranslatePipe],
  template: `
    @if (user && !user.anonymizedAt) {
      <rt-avatar
        [type]="user?.hasAvatar ? 'image' : 'initials'"
        size="small-x"
        [imageSrc]="user.photoThumbUrl"
        [initials]="user?.initials"
        margin-right-small-xx
        context="admin"
      />
    }
    @if (!user || user.anonymizedAt) {
      <rt-avatar
        type="icon"
        size="small-x"
        context="admin"
        iconName="person"
        margin-right-small-xx
      />
    }
    {{
      user && !user.anonymizedAt
        ? user.firstName + ' ' + user.lastName
        : ('app.common.deleted_user' | translate)
    }}
  `,
  styleUrls: ['./user-cell.component.less'],
  inputs: UserCellComponent.NgInputs,
})
export class UserCellComponent {
  public static NgInputs = ['user' as const];
  public user: User;
}
